import React from 'react';
import { withStyles, Theme, Tooltip } from '@material-ui/core';

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    margin: '3px',
    backgroundColor: '#FFF',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

export default HtmlTooltip;
